import { composeIO } from 'react-compose-io'
import { fieldsTipoParametroIO } from './FieldsTipoParametro.IO'
import FieldsTipoParametroView from './FieldsTipoParametro.View'

export const FieldsTipoParametro = composeIO(FieldsTipoParametroView, fieldsTipoParametroIO)
